import {
  Squares2X2Icon,
  BuildingStorefrontIcon,
  BanknotesIcon,
  BookOpenIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Partner Network Dashboard",
    href: "https://app-partnernetwork-prod.azurewebsites.net/#/",
    icon: Squares2X2Icon,
    current: false,
    internalName: "pn-dashboard",
  },
  {
    name: "Partner Network Directory",
    href: "/hub/partner-network",
    icon: BuildingStorefrontIcon,
    current: false,
    internalName: "pn-directory",
  },
  {
    name: "Report for Rebates",
    href: "https://app-partnernetwork-prod.azurewebsites.net/#/ReportRebates",
    icon: BanknotesIcon,
    current: false,
    internalName: "pn-report-rebates",
  },
  {
    name: "Rebate Guides & Resources",
    href: "https://app-partnernetwork-prod.azurewebsites.net/#/Education/ResourceGuides",
    icon: BookOpenIcon,
    current: false,
    internalName: "pn-rebate-guides",
  },
  {
    name: "Distributor Locator",
    href: "https://www.google.com/maps/d/u/0/viewer?mid=1yeeG5Q7S-b7SfcV3G_JCancHGjI0jeY&ll=39.25380072941728%2C-97.2404822625&z=4",
    icon: MapPinIcon,
    current: false,
    internalName: "pn-distributor-locator",
  },
];

const partnerNetworkConfig = {
  sectionName: "partner-network",
  defaultRoute: "/hub/partner-network",
  navigation,
};

export default partnerNetworkConfig;
